import AuthLayout from '@/components/AuthLayout'
import { useParams } from 'react-router-dom'
import { getComponents } from '../../utils/getComponents'

const Registration: React.FC = () => {
  const { page } = useParams<{ page: string }>()

  return <AuthLayout>{getComponents(page)}</AuthLayout>
}

export default Registration
